import React from 'react';
import './HghesnetProvider.css';
import Header from '../../Includes/Header';
import Footer from '../../Includes/Footer';
import provider1 from "../../Includes/Images/Image-Slider.png";
import provider2 from "../../Includes/Images/Rectangle-38-1.png";
import provider3 from "../../Includes/Images/Rectangle-39-4.png";
import provider4 from "../../Includes/Images/Rectangle-39-9.png";
import provider5 from "../../Includes/Images/Rectangle-39-7.png";
import provider6 from "../../Includes/Images/Rectangle-39-10.png";
import provider7 from "../../Includes/Images/Group-1000004733-2.png";

const HughesnetProvider = () => {
  return (
    <div className="hughesnet-page">
      <Header />
      <div className="hughesnet-container">
        {/* Header with logo */}
        <div className="hughesnet-header">
          <div className="container">
            <div className="hughesnet-logo">
              <span className="logo-text">hughesnet</span>
              <div className="authorized-retailer">
                <span>Authorized</span>
                <span>Retailers</span>
              </div>
            </div>
          </div>
        </div>

        {/* Hero section */}
        <section className="hero-section">
      <div className="container hero-wrapper">
        <div className="hero-content">
          <h1>Most advanced commercial communications satellite Internet.</h1>
          <p>The New Hughesnet Modem Features Wi-Fi 6 Technology For Enhanced Home Network Security And Is Designed To Deliver Fast Internet Speeds.</p>
          <a href="tel:+18442172287" className="phone-button">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="phone-icon">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
            </svg>
            +1-888-348-6689
          </a>
        </div>
        <div className="hero-image">
          <img src={provider1} alt="Satellite dish against blue sky" />
        </div>
      </div>
    </section>

        {/* What's New section */}
        <section className="whats-new-section">
          <div className="container">
            <h2 className="section-title">What's New</h2>

            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-image">
                  <img src={provider2} alt="Person using tablet" />
                </div>
                <div className="feature-content">
                  <h3>Reduced Latency</h3>
                  <p>The Fusion plan combines satellite and wireless technologies for a more responsive internet experience. Check for availability!</p>
                </div>
              </div>

              <div className="feature-card image-card">
                <div className="feature-image full-width">
                  <img src={provider3} alt="City skyline" />
                </div>
                <div className="feature-overlay-content">
                  <h3>Enhanced Speeds</h3>
                  <p>New satellite internet plans with speeds up to 100 Mbps*</p>
                </div>
              </div>
            </div>

            <div className="benefits-grid">
              <div className="benefit-card">
                <div className="benefit-image">
                  <img src={provider4} alt="Infinity symbol at sunset" />
                </div>
                <h3>Unlimited Data</h3>
                <p>All plans include unlimited data** so you can do more of what you love online.</p>
              </div>

              <div className="benefit-card">
                <div className="benefit-image">
                  <img src={provider5} alt="Router with hand" />
                </div>
                <h3>Whole Home Wi-Fi</h3>
                <p>All plans feature Wi-Fi 6. Add Mesh Wi-Fi Nodes to eliminate dead zones.</p>
              </div>

              <div className="benefit-card">
                <div className="benefit-image">
                  <img src={provider6} alt="Man with laptop" />
                </div>
                <h3>Available Where You Live</h3>
                <p>Even in places that are beyond the reach of cable and fiber.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Stats section */}
        <section className="stats-section">
          <div className="container stats-container">
            <div className="stats-grid">
              <div className="stat-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="stat-icon">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <h3>500+</h3>
                <p>Satellite Towers</p>
              </div>

              <div className="stat-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="stat-icon">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <h3>100+</h3>
                <p>Event spaces</p>
              </div>

              <div className="stat-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="stat-icon">
                  <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
                  <line x1="4" y1="22" x2="4" y2="15"></line>
                </svg>
                <h3>60+</h3>
                <p>Countries</p>
              </div>

              <div className="stat-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="stat-icon">
                  <path d="M5 12.55a11 11 0 0 1 14.08 0"></path>
                  <path d="M1.42 9a16 16 0 0 1 21.16 0"></path>
                  <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
                  <line x1="12" y1="20" x2="12" y2="20"></line>
                </svg>
                <h3>500 Mbps</h3>
                <p>Internet speed</p>
              </div>

              <div className="stat-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="stat-icon">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                <h3>5k+</h3>
                <p>Distributors</p>
              </div>

              <div className="stat-item">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="stat-icon">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
                <h3>200+</h3>
                <p>Communities inside</p>
              </div>
            </div>

            {/* Pricing callout */}
            <div className="pricing-callout">
              <h2>Get Business Satellite Internet Service Now</h2>
              <p className="pricing-intro">Plans as low as</p>
              <div className="pricing">
                <span className="price">$49.99</span>
                <span className="price-period">/mo</span>
              </div>
              <p className="pricing-term">for first 12 months!</p>
              <p className="pricing-note">Monthly fee includes $5 savings for ACH enrollment.</p>
              <a href="tel:+18884866689" className="phone-button">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="phone-icon">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                +1-888-348-6689
              </a>
            </div>
          </div>
        </section>

        {/* "Do it all" section */}
        <section className="do-it-all-section">
          <div className="container">
            <div className="do-it-all-content">
              <h2>Now you can do it all, wherever you live</h2>
              <a href="tel:+18884866689" className="phone-button blue">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="phone-icon">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                +1-888-348-6689
              </a>
            </div>
            <div className="people-image">
              <img src={provider7} alt="People using devices" />
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default HughesnetProvider;